import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import RadioButton from '@components/RadioButton';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Fragment, useEffect, useState } from 'react';

import { type Props } from './index';
import styles from './styles.module.scss';

function FilterBottomSheet<S, F>(props:Omit<Props<S, F>, 'title'>) {
  const {
    sortItems, filterItems, sort, setSort, filters, setFilters,
  } = props;
  // const [sort, setSort] = useState(props.sort);
  // const [filters, setFilters] = useState(props.filters);
  const toggleFilter = (filter: F) => {
    if (filters?.includes(filter)) {
      setFilters?.(filters.filter((v) => v !== filter));
    } else {
      setFilters?.([...(filters || []), filter]);
    }
  };

  return (
        <Column className={styles.sheetContainer}
                spacing={16}>
            {filterItems && (
                <Fragment>
                    <Row spacing={4}>
                        <Text size='lg' fontWeight='bold'>필터</Text>
                      {filterItems.length > 1 && (
                          <Text color={colors.gray6} fontWeight='medium'>
                            *중복 선택
                          </Text>
                      )}
                    </Row>
                    {filterItems?.map((option) => (
                        <Checkbox isChecked={filters?.includes(option.value)}
                            // @ts-ignore
                                  key={option.value}
                                  onClick={() => toggleFilter(option.value)}>
                            {option.label}
                        </Checkbox>
                    ))}
                </Fragment>
            )}
            {(sortItems && filterItems) && (
                <div className={styles.sheetDivider} />
            )}
            {sortItems && (
                <Fragment>
                    <Row spacing={4}>
                        <Text size='lg' fontWeight='bold'>정렬</Text>
                        <Text color={colors.gray6} fontWeight='medium'>*단일 선택</Text>
                    </Row>
                    <RadioButton
                        // @ts-ignore
                        options={sortItems}
                        // @ts-ignore
                        value={sort}
                        onChange={(v) => {
                          // @ts-ignore
                          setSort?.(v);
                        }} />
                </Fragment>
            )}
        </Column>
  );
}

export default FilterBottomSheet;
